/* istanbul ignore file */
import './slick-theming.css';
/** eslint-disable-next-line import/newline-after-import */
export { default } from 'react-slick';
